// Where Google sends the browser back. Exchanges the code exactly once
// (StrictMode double-mounts effects in dev, hence the ref), then lands on the
// tenants list — or shows the one uniform failure with a way back.
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router";
import { useAuth } from "../../auth/AuthContext";

export function AuthCallbackPage() {
  const { completeSignIn } = useAuth();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const exchanged = useRef(false);

  useEffect(() => {
    if (exchanged.current) return;
    exchanged.current = true;

    const code = params.get("code");
    const state = params.get("state");
    if (!code || !state) {
      setError("That sign-in link is incomplete. Start again.");
      return;
    }
    void completeSignIn(code, state).then((failure) => {
      if (failure) setError(failure);
      else void navigate("/tenants", { replace: true });
    });
    // Empty deps: the code exchange must run exactly once per mount. (No app
    // in this repo loads eslint-plugin-react-hooks, so no disable is needed —
    // referencing the unloaded rule is itself a lint error.)
  }, []);

  return (
    <div className="flex h-screen items-center justify-center bg-chrome-deep px-6">
      <div className="w-full max-w-[380px] rounded-xl bg-white p-8 text-center shadow-xl">
        {error ? (
          <>
            <p className="text-[0.85rem] text-danger">{error}</p>
            <Link
              to="/"
              className="mt-4 inline-block text-[0.8rem] font-semibold text-brand hover:underline"
            >
              Back to sign-in
            </Link>
          </>
        ) : (
          <p className="font-display text-[0.8rem] tracking-[0.1em] text-muted uppercase">
            Signing you in…
          </p>
        )}
      </div>
    </div>
  );
}
